// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AirportSearchController from "./airport_search_controller"
import AutoMomentController from "./auto_moment_controller"
import BulkSelectController from "./bulk_select_controller"
import CountupController from "./countup_controller"
import FormSubmitController from "./form_submit_controller"
import ToastController from "./toast_controller"
import GearModalController from "./gear_modal_controller"
import GearPopoverController from "./gear_popover_controller"
import NestedFormController from "./nested_form_controller"
import NestedRemoveController from "./nested_remove_controller"
import EnvelopeEditorController from "./envelope_editor_controller"
import SingleScaleModalController from "./single_scale_modal_controller"
import AircraftConfigSelectController from "./aircraft_config_select_controller"
application.register("aircraft-config-select", AircraftConfigSelectController)
application.register("airport-search", AirportSearchController)
application.register("envelope-editor", EnvelopeEditorController)
application.register("auto-moment", AutoMomentController)
application.register("bulk-select", BulkSelectController)
application.register("countup", CountupController)
application.register("form-submit", FormSubmitController)
application.register("gear-modal", GearModalController)
application.register("gear-popover", GearPopoverController)
application.register("nested-form", NestedFormController)
application.register("nested-remove", NestedRemoveController)
application.register("single-scale-modal", SingleScaleModalController)
application.register("toast", ToastController)
